module.exports = __webpack_public_path__ + "static/media/PID_Profile_Mobile.bdb65225.svg";